// Tag.tsx
import React from "react";
import Link from "next/link";
import { slugify } from "utils/utils";
interface TagProps {
  href: string;
  children: string;
}
export const Tag: React.FC<TagProps> = ({
  href,
  children
}) => {
  return <Link href={href} title={slugify(children)} className="inline-block px-3 py-1 text-sm rounded-full bg-sky-900/40 text-sky-300 hover:bg-sky-800/60 transition-colors" data-sentry-element="Link" data-sentry-component="Tag" data-sentry-source-file="index.tsx">
            #{slugify(children)}
        </Link>;
};